<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.student.setOuter') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-col cols="12">
                        <v-text-field
                            type="number"
                            :rules="etoakNoRules"
                            :label="$vuetify.lang.t('$vuetify.custom.student.outNum')+'*'"
                            v-model="formData.etoakNo"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="formData.hireDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="formData.hireDate"
                                    label="进组时间"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="formData.hireDate" locale="zh-cn" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false">取消</v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(formData.hireDate)">确定</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{$vuetify.lang.t('$vuetify.custom.cancelBtn') }}</v-btn>
                <v-btn color="success" dark @click="exportExcel">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
            </v-card-actions>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-form>
</template>
<style></style>
<script>
export default {
    name: 'choice-time',
    model: {
        prop: 'timeDialog',
        event: 'parent-event'
    },
    props: {
        timeDialog: Boolean,
        studentId: String,
    },
    data() {
        return {
            rules: {
                required: value => !!value || '请输入'
            },
            etoakNoRules: [
                v => !!v || '编号必填',
                v => (v.length >= 3 && v < 9999 && v > 0) || '001到9999',
            ],
            menu: false,
            overlay:false,
            formData:{
                hireDate:new Date().toISOString().substr(0, 10),
                etoakNo:'',
                studentId:'',
            },
        }
    },
    created() {
        this.formData.studentId = this.studentId
    },
    watch:{
        timeDialog(){
            if(this.timeDialog){
                this.formData.hireDate = new Date().toISOString().substr(0, 10)
                this.formData.studentId = this.studentId
            }
        }
    },
    methods: {
        // checkNo(){
        //     if(this.formData.etoakNo.length === 3){
        //         this.$api.outsourcingUser.exist({no:this.formData.etoakNo}).then(data => {
        //             if (data.flag) {
        //             } else {
        //                 if(data.msg)
        //                     this.formData.etoakNo = ''
        //                     this.$dialog.alert(data.msg)
        //             }
        //         })
        //     }
        // },
        hiddenDialog() {
            this.$refs.form.reset()
            this.$emit('parent-event', false);
        },
        exportExcel() {
            if (this.$refs.form.validate()) {
                this.overlay = true
                this.$api.student.add2Outsourcing(this.formData).then(data => {
                    this.overlay = false
                    if (data.flag) {
                        this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.student.setSuccess'));
                        this.$emit('initialize')
                        this.hiddenDialog();
                    } else {
                        this.$dialog.alert(data.msg)
                    }
                })
            }
        }
    },
    components:{
    },
}
</script>
